try {
  var BaseCrud = require("@/classes/metadmin/metadmin_listagem").default;
} catch (err) {
  try {
    var BaseCrud = require("@/classes/metadmin/basecrud").default;
  } catch (err) {
    var BaseCrud = require("@/framework/classes/metadmin/basecrud").default;
  }
}


export default class extends BaseCrud {
  constructor(module, lista, params, othis) {
    super(module, lista, params, othis);
    //console.log('level3')

    //this.lista.modulo.mod_titulo = 'COISA';

    /*
        this.addValidation('login',v=>{

            return "Teste! "+v
        });
        */

    this.addValidation("*", form => {
      if ((form.senha || form.senha2) && form.senha != form.senha2) {
        return "As senhas não conferem!";
      }
      if ((form.senha || form.senha2) && form.senha.length < 4) {
        return "As senhas devem possuir no mínimo 4 caracteres!";
      }

      if (this.params.action == "new" && !form.senha) {
        return "A senha deve ser preenchida!";
      }

      return true;
    });

    /*
        this.addValidation('*',form=>{
            return "Teste2! "
        });
        */
  }

  pos_edit(id, form) {
    form.senha = "";
    form.senha2 = "";
  }
}
